<template>
  <div class="header">
    <img class="menu-icon" src="/images/header/menu.svg" @click="isMenuVisible = !isMenuVisible" />
    <transition name="menu-box-transition">
      <div class="menu-box" v-if="isMenuVisible">
        <img class="menu-icon" src="/images/header/close.svg" @click="isMenuVisible = !isMenuVisible" />
        <img v-if="isMenuVisible" class="logo-title" src="/images/logo.png" />
        <div class="menu-item" v-for="parentItem in menuList" :key="parentItem.value">
          <div
            class="menu-name"
            :class="{ 'menu-name-active': activeVal === parentItem.value }"
            @click="checkoutMenu(parentItem.value)"
          >
            {{ parentItem.content }}
            <img
              v-if="parentItem.children"
              :src="activeVal === parentItem.value ? '/images/header/arrowUp.svg' : '/images/header/arrowDown.svg'"
            />
          </div>
          <div
            class="menu-content"
            :style="'max-height:' + (activeVal === parentItem.value && parentItem.children.length ? '450px' : '0')"
          >
            <div class="child-item" v-for="childItem of parentItem.children" :key="childItem.value">
              <div class="child-name" @click="openDoc(childItem.value)">{{ childItem.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <div v-if="showToast" class="toast-box">
    此功能需要大屏操作哦！
    <br />
    请用电脑浏览器打开官网继续~
  </div>
</template>

<script setup lang="ts">
import { useRouter, ref } from '#imports'
import developerDocList from '@/assets/json/developerDocList.json'

type DeveloperDoc = (typeof developerDocList)[0]

const router = useRouter()

const menuList: Partial<DeveloperDoc>[] = [
  { content: '首页', value: 'mobile' },
  { content: '启动器下载', value: 'download' },
  { content: '版本中心', value: 'versionCenter' },
  ...developerDocList
]
const activeVal = ref('')
const isMenuVisible = ref(false)
const showToast = ref(false)
let timer: number = null

function checkoutMenu(value: string) {
  switch (value) {
    // developerDocList 的 value
    case '0':
    case '1':
      activeVal.value = activeVal.value === value ? '' : value
      break
    case 'download':
    case 'versionCenter':
      showToast.value = true
      clearTimeout(timer)
      timer = window.setTimeout(() => {
        showToast.value = false
      }, 2000)
      break
    default:
      router.push('/' + value)
      isMenuVisible.value = false
  }
}

function openDoc(url: string) {
  window.open(url)
}
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  z-index: 10;
  width: 100%;

  .menu-icon {
    position: absolute;
    right: 20rem;
    top: 24rem;
  }

  .menu-box {
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    background: #110a27;
    font-size: 14rem;
    position: fixed;

    .menu-icon {
      position: absolute;
      right: 20rem;
      top: 24rem;
    }

    .logo-title {
      height: 36rem;
      margin-left: 16rem;
      margin-top: 18rem;
    }

    .menu-name {
      color: #fff;
      width: 339rem;
      height: 46rem;
      padding: 0 16rem;
      position: relative;
      margin-bottom: 16rem;
      margin-left: 16rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .menu-name::before {
      content: '';
      position: absolute;
      bottom: -8rem;
      left: 0;
      width: 100%;
      height: 1rem;
      background: rgba(255, 255, 255, 0.08);
    }

    .menu-name-active {
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.08);
    }
  }

  .menu-content {
    overflow: hidden;
    transition: all 0.3s;

    .child-name {
      color: #fff;
      width: 307rem;
      height: 46rem;
      padding-left: 16rem;
      line-height: 46rem;
      position: relative;
      margin-bottom: 16rem;
      margin-left: 48rem;
    }

    .child-name::before {
      content: '';
      position: absolute;
      bottom: -8rem;
      left: 0;
      width: 100%;
      height: 1rem;
      background: rgba(255, 255, 255, 0.08);
    }
  }
}

.toast-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  z-index: 100;
  padding: 8rem 32rem;
  width: 256rem;
  border-radius: 8rem;
  text-align: center;
  line-height: 24rem;
  font-size: 12rem;
}

.menu-box-transition-enter-active,
.menu-box-transition-leave-active {
  transition: all 0.3s ease;
}

.menu-box-transition-enter-from,
.menu-box-transition-leave-to {
  transform: translateY(-100%);
}
</style>
